// @flow
import template from '../../template';

/**
 * @private
 */
export default (): string => template`
  {
    "presets": ["lux"]
  }
`;
